import { z } from "@/zod";
import {
  nonNegativeDecimalStringSchema,
  ulid,
  createNullableBoundedNumericStringSchema,
} from "@/schemas/commonFields";
import { HOURS_WORKED_CORRECTED_MAX } from "@/constants";
import { taxStatus } from "@/schemas/commonFields/taxStatus";
import { AGREEMENT_STATUS } from "@/types/agreement";
import { applyEmptyStringsToNulls } from "@/lib/utils/zod";

const payrollDepartmentBasedInspectionBase = z.object({
  payroll_id: ulid,
  period: z.string().date(),
  department_id: ulid,
  department: z.string(),
  regional_director_id: ulid,
  regional_director: z.string(),
  regional_representative_id: ulid,
  regional_representative: z.string(),
  store_id: ulid,
  store: z.string(),
  contractor_id: ulid,
  contractor: z.string(),
  personal_id_number: z.string(),
  agreement_company_id: ulid,
  agreement_company: z.string(),
  agreement_status_period: z.enum(AGREEMENT_STATUS),
  agreement_status_current: z.enum(AGREEMENT_STATUS),
  permanent_comment: z.string(),
  tax_status_period: taxStatus,
  tax_status_current: taxStatus,
  tax_status_corrected: taxStatus.nullable(),
  tax_status_final: taxStatus,
  hourly_rate: nonNegativeDecimalStringSchema,
  hours_worked: nonNegativeDecimalStringSchema,
  hours_worked_corrected: nonNegativeDecimalStringSchema,
  hours_worked_final: nonNegativeDecimalStringSchema,
  base_amount_to_pay: nonNegativeDecimalStringSchema,
  deduction: nonNegativeDecimalStringSchema,
  penalty: nonNegativeDecimalStringSchema,
  cash_shortage: nonNegativeDecimalStringSchema,
  addition: nonNegativeDecimalStringSchema,
  bonus: nonNegativeDecimalStringSchema,
  amount_to_pay: nonNegativeDecimalStringSchema,
  comment: z.string(),
  field_account_manager_id: z.string(),
  field_account_manager: z.string(),
  student_id_valid_until: z.string(),
  is_employed: z.boolean(),
  is_student: z.boolean(),
  citizenship: z.string(),
});

export const payrollDepartmentBasedInspectionPreview =
  payrollDepartmentBasedInspectionBase
    .extend({
      id: z.string(), // Not uuid. Previews are not real entries and are generated on the fly
    })
    .readonly();

export const payrollDepartmentBasedInspection =
  payrollDepartmentBasedInspectionBase
    .extend({
      id: ulid,
    })
    .readonly();

export const updatePayrollDepartmentBasedInspection = applyEmptyStringsToNulls({
  id: ulid,
  hours_worked_corrected: createNullableBoundedNumericStringSchema({
    max: HOURS_WORKED_CORRECTED_MAX,
  }),
  deduction: nonNegativeDecimalStringSchema.nullable(),
  penalty: nonNegativeDecimalStringSchema.nullable(),
  cash_shortage: nonNegativeDecimalStringSchema.nullable(),
  addition: nonNegativeDecimalStringSchema.nullable(),
  bonus: nonNegativeDecimalStringSchema.nullable(),
  comment: z.coerce.string().max(250).nullable(),
  tax_status_corrected: taxStatus.nullable(),
});
